import { o_util } from "@gr-common/head/namespaces";
import { assignNamespace } from "@gr-common/head/namespace-utils";
import { deprecated, grScope } from "@gr-common/head/logger";

const log = grScope.scope("dom.utils");

export const getFirstElementByTagName = <K extends keyof HTMLElementTagNameMap>(
  tagName: K,
  /*                */ w = window,
): HTMLElementTagNameMap[K] => w.document.getElementsByTagName(tagName)[0];

/**
 *
 *
 */
export const getHeadElement = (w = window): HTMLHeadElement => getFirstElementByTagName("head", w);

/**
 *
 *
 */
export const getBodyElement = (w = window): HTMLBodyElement => getFirstElementByTagName("body", w);

/**
 *
 *
 *
 *
 */
export function stringToDocumentFragment(htmlString: string): DocumentFragment {
  const template = document.createElement("template");

  if (typeof htmlString !== "string") {
    log.warn(
      "stringToDocumentFragment should be called with strings containing html only, but was called with",
      typeof htmlString,
    );

    return template.content;
  }

  template.innerHTML = htmlString.trim();
  return template.content;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function hasClassInParents(ele: Element, className: string): boolean {
  return !!ele.closest(`.${className}`);
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function getParentByClassName<T extends Element>(ele: Element, className: string): T | null {
  return ele.closest(`.${className}`);
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
/*                 */
export const getElementsByClassname = <T extends Element>(
  parentElement: HTMLElement,
  className: string,
): HTMLCollectionOf<T> => parentElement.getElementsByClassName(className) as HTMLCollectionOf<T>;

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const hasClass = (element: Element, className: string): boolean =>
  element.classList.contains(className);

/**
 *
 *
 *
 *
 *
 *
 */
export const addClass = (ele: Element, cls: string): void => ele.classList.add(cls);

/**
 *
 *
 *
 *
 *
 *
 */
export const removeClass = (ele: Element, cls: string): void => ele.classList.remove(cls);

/**
 *
 *
 *
 *
 *
 *
 */
export const toggleClass = (ele: Element, cls: string): boolean => ele.classList.toggle(cls);
/*                */

assignNamespace(o_util, "dom", {
  getHeadElement,
  getBodyElement,
  getFirstElementByTagName,
  stringToDocumentFragment,

  /*                         */
  addClass: deprecated(addClass, "dom", "addClass", "use native classList.add instead"),
  getElementsByClassname: deprecated(
    getElementsByClassname,
    "dom",
    "getElementsByClassname",
    "use native getElementsByClassName instead",
  ),
  getParentByClassName: deprecated(
    getParentByClassName,
    "dom",
    "getParentByClassName",
    "use native closest instead",
  ),
  hasClass: deprecated(hasClass, "dom", "hasClass", "use native classList.contains instead"),
  hasClassInParents: deprecated(
    hasClassInParents,
    "dom",
    "hasClassInParents",
    "use native closest instead",
  ),
  removeClass: deprecated(removeClass, "dom", "removeClass", "use native classList.remove instead"),

  toggleClass: deprecated(toggleClass, "dom", "toggleClass", "use native classList.toggle instead"),
});
